import api from './axiosConfig';
import {
  LocationDto,
  LocationListResponse,
  LocationCategoryDto,
  LocationWhitelistDto,
  CreateLocation,
  UpdateLocation,
  CreateLocationCategory,
  UpdateLocationCategory,
  AddLocationWhitelist,
  UpdateLocationWhitelist,
} from '../types';

export const locationApi = {
  // ─── Locations ───────────────────────────────────────────
  getAll: async (
    searchTerm?: string,
    categoryId?: string,
    isActive?: boolean,
    pageNumber?: number,
    pageSize?: number
  ): Promise<LocationListResponse> => {
    const params: any = {};
    if (searchTerm) params.searchTerm = searchTerm;
    if (categoryId) params.categoryId = categoryId;
    if (isActive !== undefined) params.isActive = isActive;
    if (pageNumber !== undefined) params.pageNumber = pageNumber;
    if (pageSize !== undefined) params.pageSize = pageSize;
    const response = await api.get<LocationListResponse>('/locations', { params });
    return response.data;
  },

  getById: async (id: string): Promise<LocationDto> => {
    const response = await api.get<LocationDto>(`/locations/${id}`);
    return response.data;
  },

  create: async (data: CreateLocation): Promise<{ id: string }> => {
    const response = await api.post<{ id: string }>('/locations', data);
    return response.data;
  },

  update: async (id: string, data: UpdateLocation): Promise<void> => {
    await api.put(`/locations/${id}`, data);
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/locations/${id}`);
  },

  // ─── Categories ────────────────────────────────────────────
  getCategories: async (searchTerm?: string, isActive?: boolean): Promise<LocationCategoryDto[]> => {
    const params: any = {};
    if (searchTerm) params.searchTerm = searchTerm;
    if (isActive !== undefined) params.isActive = isActive;
    const response = await api.get<LocationCategoryDto[]>('/locations/categories', { params });
    return response.data;
  },

  createCategory: async (data: CreateLocationCategory): Promise<{ id: string }> => {
    const response = await api.post<{ id: string }>('/locations/categories', data);
    return response.data;
  },

  updateCategory: async (id: string, data: UpdateLocationCategory): Promise<void> => {
    await api.put(`/locations/categories/${id}`, data);
  },

  deleteCategory: async (id: string): Promise<void> => {
    await api.delete(`/locations/categories/${id}`);
  },

  // ─── Whitelist ─────────────────────────────────────────────
  getWhitelist: async (locationId?: string, employeeId?: string): Promise<LocationWhitelistDto[]> => {
    const params: any = {};
    if (locationId) params.locationId = locationId;
    if (employeeId) params.employeeId = employeeId;
    const response = await api.get<LocationWhitelistDto[]>('/locations/whitelist', { params });
    return response.data;
  },

  addWhitelist: async (data: AddLocationWhitelist): Promise<{ id: string }> => {
    const response = await api.post<{ id: string }>('/locations/whitelist', data);
    return response.data;
  },

  updateWhitelist: async (id: string, data: UpdateLocationWhitelist): Promise<void> => {
    await api.put(`/locations/whitelist/${id}`, data);
  },

  removeWhitelist: async (id: string): Promise<void> => {
    await api.delete(`/locations/whitelist/${id}`);
  },
};
